import { connect } from 'react-redux';
import { OfflineSection as OffS, Props } from './component';
import { AppState } from 'pages/app/state';
import { connectionSelector } from 'components/connection-status/selectors';

function mapStateToProps(state: AppState): Props {
  return {
    isOnline: connectionSelector(state),
  };
}

export const OfflineSection = connect(mapStateToProps)(OffS);


// WEBPACK FOOTER //
// ./src/components/offline-section/index.ts